import React, { useEffect, useState } from 'react'
import courseraIndicator from 'coursera.svg'
import { Img } from './styled'

interface IProps {
  provider: number
}

const ExternalCourseIndicator = ({ provider }: IProps) => {
  const [image, setImage] = useState('')

  useEffect(() => {
    switch (provider) {
      case 0:
        setImage(courseraIndicator)
        break
      default:
        setImage('')
        break
    }
  }, [provider])

  return <Img src={image} />
}

export default ExternalCourseIndicator
